export default {
    STRING: "string",
    ANIMAL: "animal",
    NUMBER: "number",
    DATE: "date",
    DICTIONARY: "dictionary", // dla tego trybu musi byc importDictionary
};
